import graphql__f0c6244405bfa77bab26 from "./__generated__/SidebarEventCard_participativeModule.graphql.js";import { useState } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import parseDate from "../Utils/parseDate";
import { useFormatDate } from "../Intl/Context";
import ButtonLink from "../Buttons/ButtonLink";
import { useRoutesContext } from "../Routes/RoutesContext";
import { useMapContext } from "../Maps/MapContext";

const SidebarEventCard = props => {
  const participativeModule = useFragment(
    SidebarEventCard_participativeModule,
    props.participativeModule
  );
  const { slug: eventSlug, title } = participativeModule;
  const { startsAt } = participativeModule.visualization;

  const { mapPathFor } = useMapContext();
  const isMap = !!mapPathFor;

  const onMouseEnter = () => setIsHover(true);
  const onMouseLeave = () => setIsHover(false);

  const datetime = parseDate(startsAt);
  const [isHover, setIsHover] = useState(false);
  const shadow = isHover ? "box-shadow-lg" : "box-shadow";

  const formatDate = useFormatDate();

  const startWeekday = formatDate(datetime, { weekday: "long" }, false);
  const startDay = formatDate(datetime, { day: "2-digit" }, false);
  const startMonth = formatDate(datetime, { month: "long" }, false);
  const startYear = formatDate(datetime, { year: "numeric" }, false);

  const className = classNames(
    "card",
    "box",
    "box-image",
    "h-100",
    "w-100",
    "text-reset",
    "text-decoration-none",
    shadow
  );

  const { pathFor } = useRoutesContext();
  const eventPath = isMap
    ? mapPathFor("event", { eventSlug })
    : pathFor("participativeModule", { participativeModuleSlug: eventSlug });
  const linkTarget = isMap ? undefined : "_blank";

  return (
    <li className="list-unstyled page-section-sidebar-event-card">
      <ButtonLink
        href={eventPath}
        className={className}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        target={linkTarget}
      >
        <div className="items-group flex-1">
          <div
            style={{ minWidth: "33%" }}
            className="card-panel items-group-addon padding-xs margin-right-xs text-center justify-content-center d-flex flex-column"
          >
            <div className="weekday text-title-page">{startWeekday}</div>
            <div className="day text-number-xl">{startDay}</div>
            <div className="month text-title-page">{startMonth}</div>
            <div className="year text-title-page">{startYear}</div>
          </div>

          <div className="d-flex flex-column padding-xs card-panel items-group-main">
            <div className="title flex-1 d-flex align-items-center text-title-overview">
              {title}
            </div>
          </div>
        </div>
      </ButtonLink>
    </li>
  );
};

const SidebarEventCard_participativeModule = graphql__f0c6244405bfa77bab26;

export default SidebarEventCard;
